var React = require('react');

function X (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M72 24L24 72","stroke":"black","strokeWidth":"8","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M24 24L72 72","stroke":"black","strokeWidth":"8","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

X.defaultProps = {"width":"96","height":"96","viewBox":"0 0 96 96","fill":"none"};

module.exports = X;

X.default = X;
